import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { userloginDetails } from "../Utils/AdminAuth";
import Error from "../Dashboard/Error";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";

class UserAddPrice extends Component {
  constructor() {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const empType = lStorage.user.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children

    super();

    this.state = {
      user_id: userId,
      token: userToken,
      emp_type: empType,
      permissionsubadmin: permissionsubadmin,
      successMessage: false,
      creditAmount: "",
      creditType: "",
      reMark: "",
      seletedUserId: "",
      selectedUserType: "",
      errorMessage: "",
      bgColor: "alert alert-success alert-dismissible",
      currentBalance: 0,
      currency: "",
      changeCurrency: "",
      disableButton: false,
      confirmChecked: true,
    };
  }

  componentDidMount() {
    this.getUserDetails();
    this.setState({
      seletedUserId: this.props.match.params.id,
      selectedUserType: this.props.match.params.userType,
    });
  }

  getUserDetails() {
    this.setState({ seletedUserId: this.props.match.params.id });

    fetch(`${HOST_URL}/admin_user_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        method: "retrieve",
        type: "userdetails",
        ret_user_id: this.props.match.params.id,
        token: this.state.token,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        // console.log("user", result);
        if (result.success === true) {
          this.setState({
            email: result.data[0].email,
            currentBalance: result.data[0].currency,
            currency: result.data[0].country_currency,
            changeCurrency: result.data[0].country_currency
          });
        } else {
          this.setState({
            successMessage: true,
            successBg: "alert alert-danger alert-dismissible",
            errorMessage: result.message,
          });
        }
      })
      .catch(() => {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: "Something went wrong. Please try again later.",
        });
      });
  }


  // addCredit = async() => {
  //   document.querySelector("body").scrollTo(0, 0);
  //   this.setState({disableButton: true})

  //   fetch(
  //     `${HOST_URL}/add_balance.php?user_id=${this.state.user_id}&method=add&amount=${this.state.creditAmount}&description=${this.state.reMark}&ret_user_id=${this.props.match.params.id}&credit_type=${this.state.creditType}&token=${this.state.token}`
  //   ).then((response) => {
  //     response.json().then((result) => {
  //       //  console.log(result);
  //       if (result.success === true) {
  //         this.setState({
  //           successMessage: true,
  //           bgColor: "alert alert-success alert-dismissible",
  //           errorMessage: result.message,
  //         });
  //         this.props.history.push(
  //           "/admin/user-transaction-details/" + this.props.match.params.id+"/client"
  //         );
  //         this.setState({disableButton: false})
  //       } else {
  //         this.setState({
  //           successMessage: true,
  //           bgColor: "alert alert-danger alert-dismissible",
  //           errorMessage: result.message,
  //         });
  //       }
  //     });
  //   });
  // }

  addCredit = async () => {
    this.setState({ disableButton: true });
    const paramData = {
      user_id: this.state.user_id,
      token: this.state.token,
      method: "recharge",
      recever_id: this.props.match.params.id,
      amount: this.state.creditAmount,
      des: this.state.reMark,
      des_status: this.state.confirmChecked ? 1 : 0,
      credit_type: this.state.creditType,
      currency: this.state.changeCurrency
    };
    try {
      let { data } = await Axios.post(`${NODE_HOST_URL}/user`, paramData);
      if (data.success) {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-success alert-dismissible",
          errorMessage: data.message,
        });
        this.props.history.push(
          "/admin/user-transaction-details/" +
          this.props.match.params.id +
          "/client"
        );
        this.setState({ disableButton: false });
      } else {
        this.setState({
          successMessage: true,
          bgColor: "alert alert-danger alert-dismissible",
          errorMessage: data.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <>
        <div className="wrapper">
          <AdminLeftMenu />
          <div className="main">
            <AdminHeader />
            <main className="content">
              <div className="container-fluid p-0">
                <div className="row mb-2 mb-xl-3">
                  <div className="col-auto d-none d-sm-block">
                    <h3>
                      User Details{" "}
                      <strong className="text-info">
                        {" "}
                        {this.state.email}{" "}
                      </strong>{" "}
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title mb-0">
                        <div>
                          <nav
                            className="text-center"
                            aria-label="breadcrumb"
                          >
                            <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                              <Link
                                to={
                                  "/admin/user-details/" +
                                  this.state.seletedUserId +
                                  `/` +
                                  this.state.selectedUserType
                                }
                              >
                                <li className="breadcrumb-item">
                                  User Details{" "}
                                </li>{" "}
                              </Link>

                              {(this.state.emp_type === "admin" || this.state.emp_type === "reseller" || this.state.emp_type === "emp" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.transactiondetails)) &&
                                <Link
                                  to={
                                    "/admin/user-transaction-details/" +
                                    this.state.seletedUserId +
                                    `/` +
                                    this.state.selectedUserType
                                  }
                                >
                                  <li className="breadcrumb-item">
                                    {" "}
                                    Transaction Details{" "}
                                  </li>
                                </Link>}

                              {(this.state.emp_type === "admin" || this.state.emp_type === "reseller" || this.state.emp_type === "emp" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.addeditprice)) &&
                                <Link
                                  to={
                                    "/admin/user-price-details/" +
                                    this.state.seletedUserId +
                                    `/` +
                                    this.state.selectedUserType + `?` + "channel=whatsapp"
                                  }
                                >
                                  <li className="breadcrumb-item">
                                    {" "}
                                    Add Price{" "}
                                  </li>
                                </Link>}

                              {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.awssettings)) &&
                                (
                                  <Link
                                    to={
                                      "/admin/aws-settings/" +
                                      this.state.seletedUserId +
                                      `/` +
                                      this.state.selectedUserType + `?` + "channel=whatsapp"
                                    }
                                  >
                                    <li className="breadcrumb-item">
                                      {" "}
                                      AWS Settings{" "}
                                    </li>
                                  </Link>
                                )}

                              {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.addeditprice)) &&
                                (
                                  <Link
                                    to={
                                      "/admin/user-billing-mode/" +
                                      this.state.seletedUserId +
                                      `/` +
                                      this.state.selectedUserType
                                    }
                                  >
                                    {" "}
                                    <li className="breadcrumb-item">
                                      {" "}
                                      Billing Mode{" "}
                                    </li>
                                  </Link>
                                )}

                              {(this.state.emp_type === "admin" || this.state.emp_type === "reseller" || this.state.emp_type === "emp" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.addeditcredit)) &&
                                <Link
                                  to={
                                    "/admin/user-add-price/" +
                                    this.state.seletedUserId +
                                    `/` +
                                    this.state.selectedUserType
                                  }
                                >
                                  {" "}
                                  <li className="breadcrumb-item active">
                                    {" "}
                                    Add Credit{" "}
                                  </li>
                                </Link>}


                              {this.state.emp_type === "reseller" ? null :
                                <>
                                  {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.entitybypass)) &&
                                    <Link
                                      to={
                                        "/admin/user-entity-pass/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item">
                                        {" "}
                                        Entity By Pass{" "}
                                      </li>
                                    </Link>}

                                  {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.changecurrency)) &&
                                    <Link
                                      to={
                                        "/admin/change-currency/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item ">
                                        {" "}
                                        Change Currency{" "}
                                      </li>
                                    </Link>}

                                  {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.bulksmsroutesetting)) &&
                                    <Link
                                      to={
                                        "/admin/bulk-sms-route/" +
                                        this.state.seletedUserId +
                                        `/` +
                                        this.state.selectedUserType
                                      }
                                    >
                                      {" "}
                                      <li className="breadcrumb-item ">
                                        {" "}
                                        Bulk Sms Route Setting{" "}
                                      </li>
                                    </Link>}
                                </>}

                              {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.autoshorturl)) &&
                                <Link
                                  to={`/admin/api-auto-short-url/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Auto Short URL
                                  </li>
                                </Link>}

                              {/* {this.state.emp_type === "admin" &&
                                <Link
                                  to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Extra Settings
                                  </li>
                                </Link>} */}
                              {(this.state.emp_type === "admin" || this.state.emp_type === "emp" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.extrasettings)) &&
                                <Link
                                  to={`/admin/extra-settings/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Extra Settings
                                  </li>
                                </Link>}

                              {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.mmlite)) &&
                                <Link
                                  to={`/admin/mmlite/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    MMLite
                                  </li>
                                </Link>}
                              {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.ai_bot)) &&
                                <Link
                                  to={`/admin/ai-bot/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    AI Bot
                                  </li>
                                </Link>}

                                {(this.state.emp_type === "admin" || (this.state.emp_type === "subadmin" && this.state.permissionsubadmin.edituserplan)) &&
                                <Link
                                  to={`/admin/edit-user-plan/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    Edit User Plan
                                  </li>
                                </Link>}
                                
                              {/* {this.state.emp_type === "admin" &&
                                <Link
                                  to={`/admin/ivr-setting/${this.state.seletedUserId}/${this.state.selectedUserType}`}
                                >
                                  <li className="breadcrumb-item">
                                    IVR Setting
                                  </li>
                                </Link>} */}
                            </ol>
                          </nav>
                        </div>
                      </h5>
                    </div>

                    <div className="card-body">
                      {this.state.successMessage ? (
                        <div className={this.state.bgColor} role="alert">
                          <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          <div className="">{this.state.errorMessage}</div>
                        </div>
                      ) : null}

                      <div className="filter-option">
                        <div className="row">
                          <div className="col-2">
                            <h6 className="card-subtitle text-muted">
                              Add More Credit{" "}
                            </h6>
                          </div>
                          <div className="col-6">
                            <span className="float-left">
                              <b>Current Balance:</b> {this.state.currency}{" "}
                              {this.state.currentBalance}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-8 text-right">
                            <div className="row">
                              <div className="input-group drop-down-icons mb-2 col-md-6">
                                <select
                                  onChange={(event) =>
                                    this.setState({
                                      creditType: event.target.value,
                                    })
                                  }
                                  className="form-control"
                                >
                                  <option value="">Select Credit type</option>
                                  <option value="demo credit">Demo Credit</option>
                                  <option value="paid credit">Paid Credit</option>
                                </select>
                              </div>

                              <div className="input-group mb-2 col-md-6">
                                <select className="form-control" value={this.state.changeCurrency} onChange={(e) => this.setState({ changeCurrency: e.target.value })} style={{ maxWidth: "100px" }}>
                                  <option value="INR">INR</option>
                                  <option value="EUR">EUR</option>
                                  <option value="USD">USD</option>
                                </select>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Amount"
                                  onChange={(event) =>
                                    this.setState({
                                      creditAmount: event.target.value,
                                    })
                                  }
                                />
                              </div>

                            </div>

                            <textarea
                              placeholder="Description"
                              onChange={(event) =>
                                this.setState({ reMark: event.target.value })
                              }
                              className="form-control mb-2"
                            ></textarea>

                            <div className="form-check mb-2 ml-2 float-left">
                              <input
                                className="form-check-input"
                                style={{ cursor: "pointer" }}
                                type="checkbox"
                                id="confirmCheckbox"
                                checked={this.state.confirmChecked || false}
                                onChange={(event) =>
                                  this.setState({ confirmChecked: event.target.checked })
                                }
                              />
                              <label className="form-check-label" htmlFor="confirmCheckbox">
                                Show Description to Client
                              </label>
                            </div>
                          </div>

                          <div className="col-md-4  text-right">
                            <div className="input-group mb-2 mr-sm-2">
                              <input
                                type="button"
                                onClick={() => this.addCredit()}
                                disabled={
                                  this.state.disableButton ? true : false
                                }
                                value="Add Credit"
                                className="btn btn-block btn-primary"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <AdminFooter />
          </div>
        </div>

      </>
    );
  }
}

export default UserAddPrice;
